import './honeypot.css';

interface HoneypotFieldProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

/**
 * A form field no human should ever fill in.
 *
 * Hidden with off-screen positioning rather than `display: none`,
 * `visibility: hidden`, or `type="hidden"` — form-filling bots learned
 * to skip all three years ago. A field that is present, focusable in
 * the DOM sense, and merely painted somewhere invisible still reads as
 * a real field to anything working from the markup.
 *
 * Named "website" because a naive filler is more likely to complete a
 * plausible-looking field than one called `honeypot`.
 *
 * Screen readers are explicitly excluded (aria-hidden) and it's out of
 * the tab order (tabIndex -1), so no assistive-tech user can trip it by
 * accident and get their submission silently dropped.
 */
export function HoneypotField({ value, onChange }: HoneypotFieldProps) {
  return (
    <div className="honeypot-field" aria-hidden="true">
      <label htmlFor="website-hp">
        Website (leave this field empty)
      </label>
      <input
        id="website-hp"
        type="text"
        name="website"
        value={value}
        onChange={onChange}
        tabIndex={-1}
        autoComplete="off"
      />
    </div>
  );
}
